import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Kurumsal from "../pages/kurumsal/page";
import Hizmetlerimiz from "../pages/hizmetlerimiz/page";
import DaireTemizligi from "../pages/hizmetlerimiz/daire-temizligi/page";
import BinaSiteTemizligi from "../pages/hizmetlerimiz/bina-ve-site-temizligi/page";
import ApartmanTemizligi from "../pages/hizmetlerimiz/apartman-temizligi/page";
import SiteYonetimi from "../pages/hizmetlerimiz/profesyonel-apartman-ve-site-yonetimi/page";
import InsaatSonrasiTemizlik from "../pages/hizmetlerimiz/insaat-sonrasi-temizlik/page";
import KoltukYikama from "../pages/hizmetlerimiz/koltuk-yikama/page";
import HaliYikama from "../pages/hizmetlerimiz/hali-yikama/page";
import KuruTemizleme from "../pages/hizmetlerimiz/kuru-temizleme-ve-utu/page";
import Ilaclama from "../pages/hizmetlerimiz/ilaclama/page";
import OfisTemizligi from "../pages/hizmetlerimiz/ofis-ve-is-yeri-temizligi/page";
import HizmetBolgelerimiz from "../pages/hizmet-bolgelerimiz/page";
import Saricam from "../pages/hizmet-bolgelerimiz/saricam/page";
import Cukurova from "../pages/hizmet-bolgelerimiz/cukurova/page";
import Seyhan from "../pages/hizmet-bolgelerimiz/seyhan/page";
import Yuregir from "../pages/hizmet-bolgelerimiz/yuregir/page";
import SSS from "../pages/sikca-sorulan-sorular/page";
import Iletisim from "../pages/iletisim/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/kurumsal", element: <Kurumsal /> },
  { path: "/hizmetlerimiz", element: <Hizmetlerimiz /> },
  { path: "/hizmetlerimiz/daire-temizligi", element: <DaireTemizligi /> },
  { path: "/hizmetlerimiz/bina-ve-site-temizligi", element: <BinaSiteTemizligi /> },
  { path: "/hizmetlerimiz/apartman-temizligi", element: <ApartmanTemizligi /> },
  { path: "/hizmetlerimiz/profesyonel-apartman-ve-site-yonetimi", element: <SiteYonetimi /> },
  { path: "/hizmetlerimiz/insaat-sonrasi-temizlik", element: <InsaatSonrasiTemizlik /> },
  { path: "/hizmetlerimiz/koltuk-yikama", element: <KoltukYikama /> },
  { path: "/hizmetlerimiz/hali-yikama", element: <HaliYikama /> },
  { path: "/hizmetlerimiz/kuru-temizleme-ve-utu", element: <KuruTemizleme /> },
  { path: "/hizmetlerimiz/ilaclama", element: <Ilaclama /> },
  { path: "/hizmetlerimiz/ofis-ve-is-yeri-temizligi", element: <OfisTemizligi /> },
  { path: "/hizmet-bolgelerimiz", element: <HizmetBolgelerimiz /> },
  { path: "/hizmet-bolgelerimiz/saricam", element: <Saricam /> },
  { path: "/hizmet-bolgelerimiz/cukurova", element: <Cukurova /> },
  { path: "/hizmet-bolgelerimiz/seyhan", element: <Seyhan /> },
  { path: "/hizmet-bolgelerimiz/yuregir", element: <Yuregir /> },
  { path: "/sikca-sorulan-sorular", element: <SSS /> },
  { path: "/iletisim", element: <Iletisim /> },
  { path: "*", element: <NotFound /> },
];

export default routes;